import { Divider, Drawer } from '@material-ui/core'
import CardTravelIcon from '@material-ui/icons/CardTravel'
import DashboardIcon from '@material-ui/icons/Dashboard'
import EmailIcon from '@material-ui/icons/Email'
import EventIcon from '@material-ui/icons/Event'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import PowerIcon from '@material-ui/icons/Power'
import ReceiptIcon from '@material-ui/icons/Receipt'
import SettingsIcon from '@material-ui/icons/Settings'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { Profile, SidebarNav } from './components'
const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}))

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props
  const languageFilter = useSelector(state => state.filter.language)
  const classes = useStyles()

  const pages = [
    {
      title: 'Dashboard',
      href: `/dashboard`,
      icon: <DashboardIcon />
    },
    {
      title: 'Inbox',
      href: `/dashboard/inbox`,
      icon: <EmailIcon />
    },
    {
      title: 'Calendar',
      href: `/dashboard/calendar`,
      icon: <EventIcon />
    },
    {
      title: 'Customers',
      href: `/dashboard/customers`,
      icon: <PeopleAltIcon />
    },
    {
      title: 'Venues',
      href: `/dashboard/venues`,
      icon: <CardTravelIcon />
    },
    {
      title: 'Catalog',
      href: `/dashboard/products`,
      icon: <FormatListBulletedIcon />
    },
    {
      title: 'Booking Engine',
      href: `/dashboard/booking-engine`,
      icon: <PowerIcon />
    },
    {
      title: 'Billing',
      href: `/dashboard/settings`,
      icon: <ReceiptIcon />
    },
    {
      title: 'Settings',
      href: `/dashboard/venue-settings`,
      icon: <SettingsIcon />
    },
    {
      title: 'Logout',
      href: `/user/logout`,
      icon: <ExitToAppIcon />
    }

    // {
    //   title: 'Users',
    //   href: '/users',
    //   icon: <PeopleIcon />
    // },
    // {
    //   title: 'Products',
    //   href: `/products`,
    //   icon: <ShoppingBasketIcon />
    // },
    // {
    //   title: 'Authentication',
    //   href: '/sign-in',
    //   icon: <LockOpenIcon />
    // },
    // {
    //   title: 'Typography',
    //   href: '/typography',
    //   icon: <TextFieldsIcon />
    // },
    // {
    //   title: 'Icons',
    //   href: '/icons',
    //   icon: <ImageIcon />
    // },
    // {
    //   title: 'Account',
    //   href: `/account`,
    //   icon: <AccountBoxIcon />
    // },
    // {
    //   title: 'Settings',
    //   href: `/settings`,
    //   icon: <SettingsIcon />
    // }
  ]

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
      </div>
    </Drawer>
  )
}

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
}

export default Sidebar
